import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../Providers/UserProvider";

export function ExitContainer() {
  let navigate = useNavigate();
  const { logout } = useContext(UserContext);

  useEffect(() => {
    logout();
    localStorage.removeItem("bolashak_token");
    navigate("/login");
  }, []);

  return <div>Logout</div>;
}
